import { ShapeState2D } from '../../cross-team-shared/annotation/shared/state/shape-state';
import {
  ContentUtils,
  PartiallyTransformedShape,
} from '../../team-apis/content/content-utils';
import {
  Point2D,
  VectorTaggingShapeType,
} from '../../team-apis/otterdam/answers/shape-typings';
import { getShapeHelper } from '../shared/shape-helpers/get-shape-helper';

class ContentUtils2D implements ContentUtils<Point2D, VectorTaggingShapeType> {
  addKeyLocationsToShapeExternal(
    shapeExternal: PartiallyTransformedShape<Point2D, VectorTaggingShapeType>,
  ) {
    return getShapeHelper(shapeExternal.type).addKeyLocationsToShapeExternal(
      shapeExternal,
    );
  }

  convertShapeStateToAnswer(shapeState: ShapeState2D) {
    return getShapeHelper(shapeState.type).convertShapeStateToAnswer(
      shapeState,
    );
  }
}

export const contentUtils2D = new ContentUtils2D();
